export default __webpack_public_path__ + "static/media/contact-1.9834f459.png";